module.exports = __webpack_public_path__ + "img/certification.268d0cef.svg";